/**
 * Defined action types for key learning area
 */
export const FETCH_KEY_LEARNING_AREAS = 'kla/FETCH_KEY_LEARNING_AREAS';
export const FETCH_KEY_LEARNING_AREAS_SUCCESS =
  'kla/FETCH_KEY_LEARNING_AREAS_SUCCESS';
export const FETCH_KEY_LEARNING_AREA = 'kla/FETCH_KEY_LEARNING_AREA';
export const FETCH_KEY_LEARNING_AREA_SUCCESS =
  'kla/FETCH_KEY_LEARNING_AREA_SUCCESS';
